export const getTenantAlias = (): string =>
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_TENANT_ALIAS as string)
    : globalThis.location.hostname.split('.')[0];
